import React, { useState, useMemo } from 'react'
import styled from 'styled-components/macro';
import {
  Button, Title, Form, Icon, Text
} from 'components/atoms'
import { Modal } from 'components/molecules';
import PropTypes from 'prop-types'
import { useToggle } from 'hooks';
import TextareaAutosize from 'react-autosize-textarea'
import { insertMarkdown } from 'services/helpers'
import TurndownService from 'turndown';

export const RichTextEditorOptionHtml = ({
  editorState,
  onStateChangeOptionHtml,
}) => {
  const [html, setHtml] = useState('');
  const [isOpen, toggle] = useToggle();
  const [disabled, toggleDisabled] = useToggle(false);

  const handleHtmlChange = (e) => {
    const newHtml = e.target.value;
    setHtml(newHtml);
  }

  const convertHtmlToMarkdown = () => {
    toggleDisabled();

    const turndownService = new TurndownService()
    const markdown = turndownService.turndown(html)

    insertMarkdown(editorState, onStateChangeOptionHtml, { markdown })

    setTimeout(() => {
      toggle()
      toggleDisabled();
    }, 1000)
  }

  return (
    <>
      <Modal isOpen={isOpen} toggle={toggle}>
        <Title>HTML</Title>
        <Form>
          <TextareaAutosize
            value={html}
            onChange={handleHtmlChange}
            rows={15}
            async
          />
          <Actions>
            <Button
              type="button"
              modifiers={['marginRight', 'capitalize']}
              onClick={toggle}
            >
              Cancelar
            </Button>
            <Button
              modifiers={['primary', 'capitalize', (disabled ? 'disabled' : '')]}
              onClick={convertHtmlToMarkdown}
              disabled={disabled}
            >
              Concluir
            </Button>
          </Actions>
          {
            disabled
              && (
                <Text>
                  Por favor aguarde
                </Text>
              )
          }
        </Form>
      </Modal>
      <Option onClick={toggle}>
        <Icon icon="fal fa-code" height={16} />
      </Option>
    </>
  )
}

const Option = styled.div`
    padding: ${props => props.theme.spacing.xs2};
    border-radius: 2px;
    margin: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background: ${props => props.theme.colors.bgLighterS};
    text-transform: capitalize;
    &:hover {
      background-color: #eee;
    }
`

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: ${props => props.theme.spacing.l};
`;

RichTextEditorOptionHtml.propTypes = {
  editorState: PropTypes.shape({}).isRequired,
}


export default RichTextEditorOptionHtml
